import { render, staticRenderFns } from "./LoginPassword.vue?vue&type=template&id=34a2bb08&scoped=true&"
import script from "./LoginPassword.vue?vue&type=script&lang=js&"
export * from "./LoginPassword.vue?vue&type=script&lang=js&"
import style0 from "./LoginPassword.vue?vue&type=style&index=0&id=34a2bb08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a2bb08",
  null
  
)

export default component.exports